"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingStrip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const VibescoutZIndexes_1 = require("../../../styling/VibescoutZIndexes");
const FelaCache_1 = require("../../fela/FelaCache");
const useDelayedValue_1 = require("../../hooks/useDelayedValue");
/*function useDelayedSetter<T>(target: T): T {
  const [delayedVal, setDelayedVal] = useState<T>(target);
  const timerRef = useRef();
  useEffect(() => {

  }, [target]);
}*/
const FelaKeyframesLoadingStrip = () => {
    return { "0%": { transform: "translateX(-35em)" }, "100%": { transform: "translateX(100%)" } };
    // 100% { transform: translateX(100%) };
};
const LoadingStrip = ({ bottom = false, delay = 300, zIndex = VibescoutZIndexes_1.ZIndexes.higherBar, show, }) => {
    const { theme, cachedKeyframe } = (0, FelaCache_1.useFelaCache)();
    const finalShow = (0, useDelayedValue_1.useDelayedValue)(show, delay);
    const loadingKeyFrame = cachedKeyframe(FelaKeyframesLoadingStrip, {}, "loading_strip");
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            position: "absolute",
            overflow: "hidden",
            width: "100%",
            height: "2em",
            pointerEvents: "none",
            left: 0,
            zIndex,
            ...(bottom ? { bottom: 0 } : { top: 0 }),
        }, children: (0, jsx_runtime_1.jsx)("div", { style: {
                animation: finalShow ? `${loadingKeyFrame} 2s infinite ease-in-out` : "none",
                content: "",
                position: "absolute",
                width: "100%",
                height: "100%",
                transition: "bottom 0.25s ease-out",
                bottom: show ? 0 : "100%",
                transform: "translateX(-35em)",
            }, children: (0, jsx_runtime_1.jsx)("div", { style: {
                    background: `radial-gradient(circle at 50% ${bottom ? "2300%" : "-2300%"}, rgba(${theme.styles.Colors.neutral.loading[0]},1) 0%, rgba(${theme.styles.Colors.neutral.loading[0]},1) 88%, rgba(${theme.styles.Colors.neutral.loading[0]},0) 94%, rgba(0,212,255,0) 100%)`,
                    content: "",
                    position: "absolute",
                    width: "35em",
                    height: "100%",
                    top: 0,
                    left: 0,
                } }) }) }));
};
exports.LoadingStrip = LoadingStrip;
